module.exports = __webpack_public_path__ + "static/media/manage.089202de.svg";